import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-brand-dark text-white pt-16 pb-8" data-id="element-378">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-379">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-380">
          <div className="col-span-1 md:col-span-1" data-id="element-381">
            <img className="h-24 w-auto mb-6" src="https://cdn.magicpatterns.com/uploads/jbELFVU6yimTHPdBB4r5GJ/175975597_padded_logo.png" alt="Precision Pro Sprayers" data-id="element-382" />
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-383">
              Professional grade electric sprayers built for contractors who
              need reliability and speed.
            </p>
          </div>

          <div data-id="element-384">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-385">
              Products
            </h3>
            <ul className="space-y-3" data-id="element-386">
              <li data-id="element-387">
                <Link to="/products/forcex-complete" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-388">
                  ForceX Complete Kit
                </Link>
              </li>
              <li data-id="element-389">
                <Link to="/products/forcex-diy" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-390">
                  ForceX DIY Kit
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-391">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-392">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-393">
              <li data-id="element-394">
                <Link to="/about" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-395">
                  About Us
                </Link>
              </li>
              <li data-id="element-396">
                <Link to="/warranty" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-397">
                  Warranty & Returns
                </Link>
              </li>
              <li data-id="element-398">
                <Link to="/contact" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-399">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-400">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-401">
              Contact
            </h3>
            <ul className="space-y-4" data-id="element-402">
              <li className="flex items-start" data-id="element-403">
                <Phone className="h-5 w-5 text-brand-yellow mr-3 mt-0.5" data-id="element-404" />
                <span className="text-gray-300" data-id="element-405">810-818-5941</span>
              </li>
              <li className="flex items-start" data-id="element-406">
                <Mail className="h-5 w-5 text-brand-yellow mr-3 mt-0.5" data-id="element-407" />
                <span className="text-gray-300" data-id="element-408">
                  brandon@precisionprosprayers.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-409">
          <p className="text-gray-500 text-sm" data-id="element-410">
            © {new Date().getFullYear()} Precision Pro Sprayers. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-411">
            <Link to="/warranty" className="text-gray-500 text-sm hover:text-brand-yellow" data-id="element-412">
              Privacy Policy
            </Link>
            <Link to="/warranty" className="text-gray-500 text-sm hover:text-brand-yellow" data-id="element-413">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}